'use strict';
import {Observable} from 'rxjs/Observable';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingModeSize} from '../../core-components/loading-icon/utils';
import {logger} from './logger';


TeamsEditFilterMixin.$inject = [
  '$filter',
  'BaseFilterMixin',
];

export function TeamsEditFilterMixin(
  $filter,
  BaseFilterMixin,
) {
  return function TeamManagementFilter(vm, $scope) {
    const baseFilter = new BaseFilterMixin($scope, {
      cacheId: 'TeamsEditFilterMixin',
      controllerAs: 'teamsEdit',
      filterTemplate: '',
      defaultSortProperty: 'name',
      filterOptions: {},
    });

    return {
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter),
      addSubscription: function (sub) {
        baseFilter.activeSubscriptions.push(sub);
      },
    };

    function initFiltering() {
      baseFilter.registerFilter('filteredProfileList');

      const personnelList$ = $scope.personnelList
        .$toObservable();

      const membersRelations$ = $scope.membersRelations
        .$toObservable();

      const membersList$ = $scope.membersList
        .$toObservable();

      // TODO: consider adding on child added/removed listeners to remove from in-progress status

      // TODO(perf): determine optimal order for applying the options filter vs the member filter

      const filteredList$ = Observable.combineLatest(
        personnelList$,
        membersRelations$,
        baseFilter.filterObservable,
        (personnelList, membersRelations, autoFilter) => {
          const filtered = filterPersonnelOptions(personnelList);
          const sortedByOptions = sortAssetsOptions(filtered);
          const sortedByMembers = sortByMembers(sortedByOptions, membersRelations);
          return $filter.$filterWithToString(sortedByMembers, autoFilter);
        })
        .catch(epicErrorHandler(logger, 'filteredList$'));

      // end to-do

      baseFilter.activeSubscriptions.push(updateLoadingModeSize(personnelList$, $scope, vm));

      baseFilter.activeSubscriptions.push(filteredList$.subscribe(function (results) {
        $scope.$safeApply($filter.$replaceArrayContents.bind($filter, vm.filteredProfileList, results));
      }));

      return {
        getPersonnelListObservable: () => personnelList$,
        getMembersRelationsObservable: () => membersRelations$,
        getMembersListObservable: () => membersList$,
      };
    }
  };

  function filterPersonnelOptions(list) {
    const result = [];
    const itemKeys = Object.keys(list);
    let item, i = itemKeys.length;

    while (i--) {
      try {
        item = list[itemKeys[i]];

        if (!item || item.isDeleting) continue;

        result.push(list[itemKeys[i]]);
      } catch (error) {
        // TODO: do something with this?
        console.warn('error with filterPersonnelOptions', list);
        console.error(error);
      }
    }

    return result;
  }

  function sortAssetsOptions(list) {
    return list.sort($filter.$sortByProperty('name', true));
  }

  function sortByMembers(assets, assetProjectsFilter) {
    const inProject = [];
    const notInProject = [];
    let id;

    for (let i = 0; i < assets.length; i++) {
      id = getId(assets[i]);
      if (assetProjectsFilter[id]) {
        inProject.push(assets[i]);
      } else {
        notInProject.push(assets[i]);
      }
    }

    return inProject.concat(notInProject);
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/filters/TeamsEditFilterMixin.js